export const COLORS = {
  aegean: '#00516C',
  berry: '#C473B4',
  blackMagic: '#22201D',
  blush: 'FFAFAF',
  butterscotch: '#DEB83B',
  campari: '#E84B15',
  campariText: '#DA3D07',
  coral: '#EC6269',
  creme: '#F5F3ED',
  darkGray: '#999999',
  french: '#416CAA',
  grapeSoda: '#9E2986',
  gray: '#E5E5E5',
  kermit: '#008557',
  lilac: '#DBC4E1',
  liquorice: '#000',
  lobsterOrange: '#FF8A3D',
  military: '#888E64',
  mint: '#D8EACC',
  monster: '#C2E189',
  moss: '#205C40',
  oatmeal: '#DFC4AC',
  ocean: '#40C1AC',
  oceanText: '#058671',
  oyster: '#403b3b',
  parsley: '#2AAB5E',
  peach: '#F8A78A',
  piglet: '#F0CAD2',
  poppy: '#E8443B',
  purpleish: '#971797',
  river: '#A7C6ED',
  rust: '#D14124',
  seafoam: '#40C1AB',
  slate: '#757778',
  smoke: '#CCC7BF',
  snow: '#FFF',
  squidInk: '#1b294a',
  submarine: '#FFCC00',
  sunshine: '#f3a90b',
  whitish: '#FBFAF8',
  yolk: '#F6A800',
};
